module.exports = __webpack_public_path__ + "static/media/life-overview-banner-mobile.45d0fe9a.jpg";